import { ArrowLeftIcon } from "@heroicons/react/outline";
import { LoadingModal } from "Component/LoadingModal";
import { Notify } from "Component/Notify";
import { fetchApi } from "Config/fetchApi";
import React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import { ROUTES } from "Route/ConstantRoute";
import { EncryptStorage } from "encrypt-storage";
import { handleError } from "Helper";

function UpdateCameraInventory() {
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const userInfo = encryptStorage.getItem("___info");
  const yuridiksi_user_code = userInfo?.jurisdiction_level_code || "";
  const navigate = useNavigate();
  const location = useLocation();
  const argumentData = location.state;
  const [uuid] = useState(argumentData?.uuid || "");
  const [isLoading, setIsLoading] = useState(false);
  const [deviceName, setDeviceName] = useState(
    argumentData?.namaPerangkat || ""
  );
  const [modelDevice, setModelDevice] = useState(argumentData?.tipeModel || "");
  const [urlRtsp, setUrlRtsp] = useState(argumentData?.deviceUrlRtsp || "");
  const [simcard, setSimcard] = useState(argumentData?.nomorSimcard || "");
  const [inventoryId, setInventoryId] = useState(
    argumentData?.inventoriKendaraanId || ""
  );

  const [deviceTypeID, setDeviceTypeID] = useState(
    argumentData?.deviceTypeId || ""
  );
  const [dataDeviceType, setDataDeviceType] = useState([]);
  const [dataVehicle, setDataVehicle] = useState([]);

  // ==================== Default ==================== //
  const goBack = () => {
    navigate(ROUTES.inventory.camera.camera_home);
  };

  const handleSuccess = (message) => {
    Notify.success({
      title: "Berhasil",
      description: message,
    });
  };

  const getDataDeviceType = async () => {
    try {
      const response = await fetchApi().get(`/device-type/get-list`);
      const filterFlagData = response.data?.data.filter(
        (item) => item.flag_active_device_type === true
      );
      setDataDeviceType(filterFlagData);
      setIsLoading(false);
    } catch (err) {
      setDataDeviceType([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const getDataVehicle = async () => {
    try {
      const response = await fetchApi().get(`/inventory-kendaraan/get-list`);
      const onlyMotor = response.data?.data.filter(
        (item) => item.is_active === true && item.jenis_kendaraan === "MOTOR"
      );
      setDataVehicle(onlyMotor);
      setIsLoading(false);
    } catch (err) {
      setDataVehicle([]);
      setIsLoading(false);
      handleError(err);
    }
  };
  // ==================== Default ==================== //

  const updateData = async () => {
    try {
      setIsLoading(true);
      let reqBody;
      if (deviceTypeID !== "c4064919-9bc3-417a-af39-aa031de96dda") {
        reqBody = {
          nama_perangkat: deviceName,
          device_type_id: deviceTypeID,
          tipe_model: modelDevice,
          device_url_rtsp: urlRtsp,
        };
      } else {
        reqBody = {
          nama_perangkat: deviceName,
          device_type_id: deviceTypeID,
          tipe_model: modelDevice,
          device_url_rtsp: urlRtsp,
          nomor_simcard: simcard,
          inventori_id: inventoryId,
        };
      }
      const response = await fetchApi().put(
        `/inventory-camera/update/${uuid}`,
        reqBody
      );

      setIsLoading(false);
      handleSuccess(`Data ${deviceName} berhasil diperbarui`);
      goBack();
    } catch (err) {
      setIsLoading(false);
      handleError(err);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updateData();
  };

  useEffect(() => {
    getDataDeviceType();
    getDataVehicle();
  }, []);

  return (
    <div>
      <div className="text-lg font-bold text-start gap-2 pb-5">
        <p
          className="text-2xl font-bold"
          style={{
            fontFamily: "Poppins",
          }}
        >
          Ubah Inventaris Kamera
        </p>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="rounded-2xl border border-gray-300 shadow-xl bg-white p-6">
          <div className="flex flex-col md:flex-row justify-between items-center px-5 w-full gap-4">
            <div className="w-full md:w-2/4">
              <button
                type="submit"
                onClick={goBack}
                disabled={isLoading}
                className="bg-zinc-200 h-11 flex w-auto justify-center items-center rounded-xl hover:bg-gray-100 px-3 py-1.5 text-md font-semibold leading-6 text-black focus-visible:outline shadow-md focus-visible:outline-2 focus-visible:outline-offset-2"
              >
                <ArrowLeftIcon className="h-6 w-auto pr-2" />
                Kembali
              </button>
            </div>
          </div>

          {/* Field Kolom 1 */}
          <div className="flex flex-col md:flex-row justify-between gap-4 py-5 px-5 w-full">
            <div className="w-full md:w-1/3">
              <label
                htmlFor="nama_perangkat"
                className="block text-sm font-medium leading-6"
              >
                Nama Perangkat <span className="text-red-700">*</span>
              </label>
              <div className="mt-2">
                <input
                  id="nama_perangkat"
                  name="nama_perangkat"
                  type="text"
                  disabled={isLoading}
                  value={deviceName}
                  placeholder="Masukkan Nama Perangkat"
                  onChange={(e) => setDeviceName(e.target.value)}
                  required
                  className="capitalize h-11 block px-2 w-full rounded-xl border border-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm"
                />
              </div>
            </div>
            <div className="w-full md:w-1/3">
              <label
                htmlFor="operation_name"
                className="block text-sm font-medium leading-6"
              >
                Jenis Perangkat <span className="text-red-700">*</span>
              </label>
              <div className=" relative mt-2">
                <select
                  id="device_type"
                  name="device_type"
                  required
                  value={deviceTypeID}
                  onChange={(e) => setDeviceTypeID(e.target.value)}
                  className="h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none"
                >
                  <option
                    value=""
                    disabled
                    hidden
                    className=" placeholder:text-gray-400 "
                  >
                    Pilih Jenis Perangkat
                  </option>
                  {dataDeviceType.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.device_type_name}
                    </option>
                  ))}
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <svg
                    className="w-5 h-5 text-gray-400"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className="w-full md:w-1/3">
              <label
                htmlFor="tipe_model"
                className="block text-sm font-medium leading-6"
              >
                Model
              </label>
              <div className="mt-2">
                <input
                  id="tipe_model"
                  name="tipe_model"
                  type="text"
                  disabled={isLoading}
                  placeholder="Isikan Model Perangkat"
                  value={modelDevice}
                  onChange={(e) => setModelDevice(e.target.value)}
                  className="capitalize h-11 block px-2 w-full rounded-xl border border-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm"
                />
              </div>
            </div>
          </div>

          {/* Field Kolom 2 */}
          <div className="py-5 px-5 w-full">
            <div className="w-full">
              <label
                htmlFor="device_url_rtsp"
                className="block text-sm font-medium leading-6"
              >
                RTSP
              </label>
              <div className="mt-2">
                <input
                  id="device_url_rtsp"
                  name="device_url_rtsp"
                  type="text"
                  disabled={isLoading}
                  value={urlRtsp}
                  placeholder="Masukkan URL RTSP Kamera"
                  onChange={(e) => setUrlRtsp(e.target.value)}
                  className="capitalize h-11 block px-2 w-full rounded-xl border border-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm"
                />
              </div>
            </div>
          </div>

          {/* Field Kolom 3 */}
          {deviceTypeID === "c4064919-9bc3-417a-af39-aa031de96dda" && (
            <div className="flex flex-col md:flex-row justify-between gap-4 py-5 px-5 w-full">
              <div className="w-full md:w-1/3">
                <label
                  htmlFor=" nomor_simcard"
                  className="block text-sm font-medium leading-6"
                >
                  Nomor Simcard
                </label>
                <div className="mt-2">
                  <input
                    id=" nomor_simcard"
                    name=" nomor_simcard"
                    type="text"
                    disabled={isLoading}
                    placeholder="Masukkan Nomor SIM Perangkat"
                    value={simcard}
                    onChange={(e) => setSimcard(e.target.value)}
                    className="capitalize h-11 block px-2 w-full rounded-xl border border-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm"
                  />
                </div>
              </div>
              <div className="w-full md:w-2/3">
                <label
                  htmlFor="inventori_id"
                  className="block text-sm font-medium leading-6"
                >
                  Tautkan Kendaraan
                </label>
                <div className="mt-2 relative w-full">
                  <select
                    id="inventori_id"
                    name="inventori_id"
                    value={inventoryId}
                    onChange={(e) => setInventoryId(e.target.value)}
                    className={`h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none ${
                      inventoryId === "" ? "text-gray-400 " : "text-gray-700"
                    }`}
                  >
                    <option
                      value=""
                      onChange={(e) => setInventoryId(e.target.value)}
                    >
                      --Pilih Kendaraan--
                    </option>

                    {Array.isArray(dataVehicle) &&
                      dataVehicle.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.nama_kendaraan}
                        </option>
                      ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="flex justify-end px-5">
            <button
              type="submit"
              className="h-11 flex w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-4 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              Simpan
            </button>
          </div>
        </div>
      </form>
      <LoadingModal open={isLoading} />
    </div>
  );
}

export default UpdateCameraInventory;
